export const PARKING_OPTIONS = [
  { value: '0', label: 'No' },
  { value: '1', label: 'Yes' },
]

export const CHECK_IN_DATE_FORMAT = 'dd MMM yyyy'

export const BEDROOM_OPTIONS = [
  { value: -1, label: 'Hotel room' },
  { value: 0, label: 'Studio' },
  { value: 1, label: '1 Bedroom' },
  { value: 2, label: '2 Bedrooms' },
  { value: 3, label: '3 Bedrooms' },
  { value: 4, label: '4 Bedrooms' },
  { value: 5, label: '5 Bedrooms' },
]

export const PETS_FIELD_FORM_RULES = {
  maxLength: {
    value: 255,
    message: 'This field cannot be longer than 255 characters.',
  },
}
